import React from 'react';
import { Armchair, CheckCircle, Clock, UserPlus, Users, XCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

function StatCard({ label, value, icon: Icon, colorClass, subText }) {
  return (
    <div className={cn('relative overflow-hidden rounded-lg border bg-card p-3 shadow-sm', colorClass)}>
      <div className="z-10 flex items-start justify-between">
        <div>
          <p className="mb-0.5 text-[10px] font-semibold uppercase tracking-wider opacity-70">{label}</p>
          <h3 className="text-2xl font-bold leading-none">{value}</h3>
          {subText ? <p className="mt-1 text-[10px] opacity-60">{subText}</p> : null}
        </div>
        <div className="rounded-full bg-background/20 p-1.5 backdrop-blur-sm">
          <Icon className="h-4 w-4" />
        </div>
      </div>
    </div>
  );
}

export default function StatsCardsRow({ stats }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
      <StatCard label="Bookings" value={stats.total} icon={Clock} colorClass="border-blue-100 bg-blue-50/50 text-blue-900" />
      <StatCard label="Gaeste" value={stats.totalGuests} icon={Users} colorClass="border-indigo-100 bg-indigo-50/50 text-indigo-900" />
      <StatCard
        label="Anwesend"
        value={stats.seated}
        icon={Armchair}
        colorClass="border-green-100 bg-green-50/50 text-green-900"
        subText={`${Math.round((stats.seated / (stats.total || 1)) * 100)}% vom Tag`}
      />
      <StatCard label="Bestaetigt" value={stats.confirmed} icon={CheckCircle} colorClass="border-emerald-100 bg-emerald-50/50 text-emerald-900" />
      <StatCard label="Offen" value={stats.pending} icon={UserPlus} colorClass="border-amber-100 bg-amber-50/50 text-amber-900" />
      <StatCard label="Ausfaelle" value={(stats.noShow || 0) + (stats.cancelled || 0)} icon={XCircle} colorClass="border-rose-100 bg-rose-50/50 text-rose-900" />
    </div>
  );
}
